'use strict';

wbApp.controller('DuePaymentPaymentsCtrl', ['$scope', '$window', '$translate', '$filter', 'paymentsSvc', 'securitySvc',
function ($scope, $window, $translate, $filter, paymentsSvc, securitySvc) {



    var isActive = false;
    var loaded = false;
    $scope.invoiceID = null;
    $scope.payments = [];

    $scope.$on('selectedDuePaymentChanged', function (e, data) {

        if (data) {
            if (data.invoiceID !== $scope.invoiceID || !loaded) {
                $scope.invoiceID = data.invoiceID;
                if (isActive) {
                    $scope.payments = paymentsSvc.getAllRelatedPaymentsByInvoiceID(data.invoiceID);
                    loaded = true;
                } else {
                    loaded = false;
                }
            }
        } else {
            $scope.payments.length = 0;
            loaded = false;
        }
    });


    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 4) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.invoiceID) {
                    $scope.payments = paymentsSvc.getAllRelatedPaymentsByInvoiceID($scope.invoiceID);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });


    $scope.paymentsGridSettings = {
        name: 'payments',
        columns: [
            {
                dataField: 'typeID',
                caption: $translate.instant("TXT_LBL_TYPE"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('invoiceForType')(rowData.typeID);
                },
                width: '55px'
            },
            { dataField: 'subject', caption: $translate.instant('TXT_LBL_SUBJECT'), dataType: 'string', sortOrder: 'dsc' },
            { dataField: 'notes', caption: $translate.instant('TXT_NOTE'), dataType: 'string' },
            { dataField: 'value', caption: $translate.instant('TXT_LBL_AMOUNT'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            {
                dataField: 'paymentTypeID',
                caption: $translate.instant("TXT_LBL_PAYMENT"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('paymentType')(rowData.paymentTypeID);
                },
                width: '70px'
            },
            { dataField: 'paymentDate', caption: $translate.instant('TXT_LBL_DATE'), dataType: 'date', width: '90px', sortOrder: 'asc' },
            { dataField: 'invoiceNo', caption: $translate.instant('TXT_LBL_INVOICE_NO'), dataType: 'string', width: '90px', visible: false },
            {
                dataField: 'terminalID',
                caption: $translate.instant('TXT_LBL_TERMINAL'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('terminal')(rowData.terminalID);
                },
                width: '150px',
                visible: false
            }
        ]
    }
   
}]);